import {
  Component,
  AfterViewInit,
  EventEmitter,
  Output,
  OnInit,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { Globals } from "../../common/global";
import { ToastrService } from "ngx-toastr";
import { BnNgIdleService } from "bn-ng-idle"; // import it to your component

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
})
export class NavigationComponent implements AfterViewInit, OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};

  user: any = "";
  ride: any;
  activeplan: any;
  renewon: any;
  commission: any;
  planePrice: any;
  isEmpoyee = false;
  isAssetsRegistered = false;
  modeltitle: any;
  allcountry: any;

  operatingHoursData: any = {
    isOn: false,
    openingTime: "",
    closingTime: "",
  };

  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    public routes: Router,
    private http: HttpClient,
    private router: Router,
    private apiCallingService: ApiCallingService,
    public globals: Globals,
    private bnIdle: BnNgIdleService,
    private toastr: ToastrService
  ) {
    translate.setDefaultLang("en");
  }

  ngOnInit() {
    this.user = this.globals.getUser();
    this.activeplan = this.user?.subscription?.name;
    this.planePrice = this.user?.subscription?.price;
    this.planePrice = this.planePrice ? this.planePrice : 0;
    this.isAssetsRegistered = this.user.flags.is_assets_registered;
    this.renewon = this.user?.subscription?.end_date;
    this.commission = this.user?.commissionPercent;
    this.getRides();
    this.bnIdle.startWatching(600).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        this.toastr.error("Sorry,Timout due to inactivities");
        this.logout();
      }
    });
  }

  ngAfterViewInit() {
    this.isEmpoyee =
      localStorage.getItem("is_loginEmployee") == "true" ? true : false;
  }

  getRides() {
    const user_id = this.globals.user._id;

    const query = "?user_id=" + user_id + "&limit=10&page=10";
    this.apiCallingService
      .callAPI({}, "GET", ConfigApi.URLS.GET_RIDE_HISTORY + query)
      .subscribe((res) => {
        this.ride = res.count;
      });
  }

  getInitials(name: string): string {
    if (!name) return "";
    const names = name.trim().split(" ");
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    } else {
      return (
        names[0].charAt(0) + names[names.length - 1].charAt(0)
      ).toUpperCase();
    }
  }

  changeLanguage(lang: any) {
    this.translate.use(lang.code);
  }

  openModal(targetModal: NgbModal, title: any) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
    if (title == "Cancel") {
      this.modeltitle = "Cancel plan";
    } else {
      this.modeltitle = "Remove account completely";
    }
  }

  closeBtnClick() {
    this.modalService.dismissAll();
  }

  logout() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.LOGOUT_URL + "/" + this.globals.getUser()._id
      )
      .subscribe((res) => {
        localStorage.removeItem("Auth-user");
        localStorage.removeItem("operator_details");
        localStorage.removeItem("is_loginEmployee");
        location.reload();
        this.router.navigate(["/login"]);
      });
  }

  removeAccount() {
    const body = new HttpParams()
      .set("email", this.globals.getUser().email)
      .set("in_blocked", "true");
    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.REMOVE_ACCOUNT)
      .subscribe((res) => {
        this.toastr.success(res.msg);
        this.closeBtnClick();
        localStorage.removeItem("Auth-user");
        localStorage.removeItem("is_loginEmployee");
        this.router.navigate(["/login"]);
      });
  }

  cancelPlan() {
    const param =
      "?user_id=" + this.user._id + "&package_id=" + this.user.subscription._id;
    this.apiCallingService
      .callAPI({}, "GET", ConfigApi.URLS.CANCEL_PLAN + param)
      .subscribe((res) => {
        this.toastr.success(res.msg);
        this.globals.setUser(res.data);
        location.reload();
        this.closeBtnClick();
      });
  }

  // Operating Hours Methods
  openOperatingHoursModal(targetModal: NgbModal) {
    let user_id =
      localStorage.getItem("is_loginEmployee") == "true"
        ? this.globals.getUser().operator_id._id
        : this.globals.user._id;
    this.apiCallingService
      .callAPI({}, "GET", ConfigApi.URLS.EMPLOYEE.GET_DETAILS + user_id)
      .subscribe((res) => {
        const openingDate = new Date(res.data.openingHours);
        const closingDate = new Date(res.data.closingHours);

        const formatTime = (date: Date) => date.toTimeString().slice(0, 8); // Gets "HH:mm"

        this.operatingHoursData = {
          isOn: res.data.isOn,
          openingTime: formatTime(openingDate),
          closingTime: formatTime(closingDate),
        };
      });

    this.loadOperatingHours();
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  loadOperatingHours() {
    // You can load existing operating hours from API if needed
    // For now, using default values
    const user_id = this.globals.user._id;

    // Example of how you might fetch existing data
    // this.apiCallingService
    //   .callAPI({}, "GET", ConfigApi.URLS.GET_OPERATING_HOURS + "?user_id=" + user_id)
    //   .subscribe((res) => {
    //     if (res.success) {
    //       this.operatingHoursData = {
    //         isOn: res.data.isOn,
    //         openingTime: this.formatTimeForInput(res.data.openingHours),
    //         closingTime: this.formatTimeForInput(res.data.closingHours)
    //       };
    //     }
    //   });
  }

  formatTimeForInput(dateTimeString: string): string {
    // Convert datetime string to time format for input
    if (!dateTimeString) return "11:53";
    const date = new Date(dateTimeString);
    return `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}`;
  }

  onOpeningTimeChange() {
    if (
      this.operatingHoursData.closingTime &&
      this.operatingHoursData.closingTime < this.operatingHoursData.openingTime
    ) {
      this.operatingHoursData.closingTime = "";
    }
  }
  onToggleOperatingHours() {
    if (!this.operatingHoursData.isOn) {
      this.operatingHoursData.openingTime = "";
      this.operatingHoursData.closingTime = "";
    }
  }
  submitOperatingHours() {
    if (this.operatingHoursData.isOn) {
      console.log("Operating hours submitted:", this.operatingHoursData);
    }
    const user_id = this.globals.user._id;
    const today = new Date();
    const year = today.getFullYear();
    const month = ("0" + (today.getMonth() + 1)).slice(-2);
    const day = ("0" + today.getDate()).slice(-2);
    const dateString = `${year}-${month}-${day}`; // Format: YYYY-MM-DD

    const payload = {
      isOn: this.operatingHoursData.isOn,
      ...(this.operatingHoursData.isOn && {
        openingHours: `${dateString} ${this.operatingHoursData.openingTime}`,
        closingHours: `${dateString} ${this.operatingHoursData.closingTime}`,
      }),
    };

    this.apiCallingService
      .callAPI(
        payload,
        "POST",
        ConfigApi.URLS.EMPLOYEE.SET_OPERATING_HOURS + "/" + user_id
      )
      .subscribe(
        (res) => {
          if (res.success) {
            // let existingAuthUser = localStorage.getItem("Auth-user");
            // if (existingAuthUser) {
            //   let parsedAuthUser = JSON.parse(existingAuthUser);
            //   let authUser = {
            //     isOn: res.data.isOn,
            //     openingTime: res.data.openingHours,
            //     closingTime: res.data.closingHours,
            //   };
            //   parsedAuthUser.businessDetails = authUser;
            //   localStorage.setItem("Auth-user", JSON.stringify(parsedAuthUser));
            // }

            this.toastr.success(
              res.msg || "Operating hours updated successfully"
            );
            this.closeBtnClick();
          } else {
            this.toastr.error(res.msg || "Failed to update operating hours");
          }
        },
        (error) => {
          this.toastr.error("An error occurred while updating operating hours");
          console.error(error);
        }
      );
  }
}
